<template>
  <div id="contenedor-eliminar-auditoria-informe-observacion">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Observación </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la Observación? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{observacion.numero}}
          </span>
        </v-row>
        <v-row>
          <span> <cortar-texto
          :texto="observacion.descripcion">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoriaInformeObservacion"
          :disabled="enviandoFormulario || tieneDependencias || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixObservaciones from './mixObservaciones';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContenedorEliminarAuditoriaInformeObservacion',
  props: {
    observacion: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixObservaciones],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarAuditoriaInformeObservacion() {
      this.enviandoFormulario = true;
      this.mixEliminarAuditoriaInformeObservacion();
    },
  },
  computed: {
    tieneDependencias() {
      return this.observacion.detalles.length > 0;
    },
  },
};
</script>
